// extracted by mini-css-extract-plugin
export default {"nextButton":"ButtonsGroup_nextButton__GXBgr","previousButton":"ButtonsGroup_previousButton__X2J8p"};